import { UNIVERSAL_ENV_VARS } from '../../constants/environmentVariables';
import { isProduction } from '../../helpers/environment/isProduction';
import { reportMykissClientError } from '../../helpers/errorHandling/client';
import { logger } from '../../helpers/logging';
import { JSON_HEADERS, post } from './shared';

export async function postSignupVerification(
  castleToken: string | undefined,
  authToken: string,
): Promise<void> {
  if (isProduction() || UNIVERSAL_ENV_VARS.FORCE_CASTLE_USAGE) {
    if (!castleToken) {
      logger.warn('No Castle token provided for post-signup verification');
    } else {
      try {
        await post(
          encodeURI(`/user_verification/post_sign_up`),
          async () => Promise.resolve(authToken),
          false,
          { castle_token: castleToken },
          JSON_HEADERS,
        );
      } catch (error) {
        logger.error('Error during post-signup verification:', error);
        reportMykissClientError(error);
      }
    }
  }
}
